import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { State } from '../../services/global-state';
import { PayrazrService } from '../../services/payrazr';
import { MessagesService } from '../../services/messages.service';
import { I18N } from 'aurelia-i18n';

@autoinject
export class Messages {
	isLoading = true;
	messages = [];

	constructor(private messagesServices: MessagesService, private router: Router, private i18n: I18N) {
	}

	markAsRead(message) {
		this.messagesServices.markAsRead(message);
	}

	onMessageClicked(message) {
		if (message.linkText === 'See Documents') {
			this.router.navigate('docs');
		}
	}

	get notification() {
		let msgCount = this.messagesServices.newMessages ? this.messagesServices.newMessages : 0;
		return this.i18n.i18next.t('youHaveXNewMessage', {defaultValue: `You have ${msgCount} new message`, count: msgCount}) + (msgCount === 1 ? '' : 's');
	}

	attached() {
		this.messagesServices.getMessages()
			.then(() => {
				this.isLoading = false;
				this.messages = this.messagesServices.messages;
			});
	}
}
